import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import TeamMemberRowActionButtons from '@components/table/actionButtons/TeamMemberRowActionButtons';

import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import DataTable from '../dataTable';
import translateColumns, { translateSort } from '../dataTable/dataTranslate';

const TeamLeadersTable = ({
  id = 'teamLeadersTable',
  displayData,
  showDeleteButton = true,
  onMemberDelete,
  showStartImpersonationButton = false,
  isModal = false,
}) => {
  const onDeleteRow = row => onMemberDelete(row);

  const actionsFormatter = (cell, row) => (
    <TeamMemberRowActionButtons
      showDeleteButton={showDeleteButton}
      onDeleteRow={onDeleteRow}
      showStartImpersonationButton={showStartImpersonationButton}
      currRow={row}
    />
  );

  const columns = [
    {
      dataField: 'TeamLeadFullName',
      text: 'Name',
      formatter: cell => (
        <Stack direction="row" alignItems="center" gap={1}>
          <Avatar
            sx={{ width: 30, height: 30 }}
            alt={cell}
            src="/broken-image.jpg"
          />
          {cell}
        </Stack>
      ),
      sort: true,
      headerStyle: { width: '175px' },
    },
    {
      dataField: 'TeamLeadMlsId',
      text: 'MLS ID',
      sort: true,
      headerStyle: { width: '65px' },
    },
    {
      dataField: 'TeamLeadOfficeName',
      text: 'Office',
      sort: true,
    },
    {
      dataField: 'actions',
      text: '',
      formatter: actionsFormatter,
      headerStyle: { width: '30px' },
    },
  ];

  const defaultSorted = [{
    dataField: 'TeamLeadFullName',
    order: 'desc',
  }];

  const newCols = useMemo(() => translateColumns(columns), [columns]);

  return (
    <DataTable
      defaultSorted={translateSort(defaultSorted)}
      columns={newCols}
      sizePerPage={isModal ? 5 : 10}
      data={displayData}
      wrapperClasses="table-responsive"
      id={id}
      noDataIndication="No Data Returned."
      classes="dataTable"
      striped
      hover
    />
  );
};

TeamLeadersTable.propTypes = {
  id: PropTypes.string,
  displayData: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  showDeleteButton: PropTypes.bool,
  onMemberDelete: PropTypes.func,
  showStartImpersonationButton: PropTypes.bool,
  isModal: PropTypes.bool,
};

export default TeamLeadersTable;
